import { faCheck } from '@fortawesome/pro-solid-svg-icons'

export enum UserRoles {
  ADMINISTRATOR = 'administrator',
  SUPER_ADMINISTRATOR = 'super_administrator',
  COLLABORATOR = 'collaborator',
  MODERATOR = 'moderator',
  SUPERVISOR = 'supervisor',
}

const {
  ADMINISTRATOR,
  SUPER_ADMINISTRATOR,
  MODERATOR,
  COLLABORATOR,
  SUPERVISOR,
} = UserRoles

export const admins = [ADMINISTRATOR, SUPER_ADMINISTRATOR] as const
export const allRoles = [
  ...admins,
  MODERATOR,
  COLLABORATOR,
  SUPERVISOR,
] as const

export const productItems = [
  {
    active: true,
    external: false,
    icon: faCheck,
    code: 'rkm_01',
    order: 1,
    text: 'Producto 1',
    url: '',
  },
  {
    active: true,
    external: false,
    icon: faCheck,
    code: 'rkm_02',
    order: 2,
    text: 'Producto 2',
    url: '',
  },
  {
    active: true,
    external: false,
    icon: faCheck,
    code: 'rkm_03',
    order: 3,
    text: 'Producto 3',
    url: '',
  },
]
